export function checkResponseCodeHasMDIP(responseCode: string): boolean {
    return /mdip/i.test(responseCode);
}
